import React from 'react'
import { deleteProjectunit } from '../../store/actions/index';
import DeleteModal from './DeleteModal';
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const DeleteProjectunitModal = (props) => {

  const projectunit = useSelector(state => state.modal.modalProps.projectunit)
  const { t } = useTranslation();
  const ht = useCustomHtmlTranslation();

  const onSubmitAction = (values) => {
    return deleteProjectunit(projectunit)
  };

  const redirectTo = () => {};

  return (
    <DeleteModal
      modalTitle={ t( 'modal.delete_projectunit.title' ) }
      onSubmitAction={onSubmitAction}
      redirectTo={redirectTo}
    >
    { ht('modal.delete_projectunit.text', {projectunit_title: projectunit.title}) }
    </DeleteModal>
  )
}

export default DeleteProjectunitModal



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteProjectunitModal.js